export default __webpack_public_path__ + "static/media/fallout-mutation-from.4f99bdba.png";